import { PATH } from "routes/paths";

// 로그인 후 복귀 목적지 해석 — 보호 페이지 가드(<Navigate state.from>)나 401 인터셉터(?returnTo=)가 전달한
// 경로를 검증한다. 내부 절대 경로("/...")만 허용해 외부 도메인·프로토콜 상대("//host") 오픈 리다이렉트를 차단하고,
// 로그인 페이지 자신이 오면 리다이렉트 루프를 막기 위해 홈으로 폴백한다.
export const resolveAmbassadorReturnTo = (
  raw: string | null | undefined
): string => {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//")) {
    return PATH.ambassador;
  }
  if (
    raw === PATH.ambassadorLogin ||
    raw.startsWith(`${PATH.ambassadorLogin}?`)
  ) {
    return PATH.ambassador;
  }
  return raw;
};
